import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

import { InformacaoDialog } from '../models/informacaoDialog.model';

@Injectable()
export class ObservadorSharedService {
  constructor() {}

  // Observable para emitir informacoes para a dialog
  subjectInformacaoDialog: Subject<InformacaoDialog> =
    new Subject<InformacaoDialog>();

  // Subject do valor do input da dialog
  subjectValorInputDialog: Subject<string> = new Subject<string>();

  // Subject mensagem feedback input dialog
  subjectMensagemFeedBackInputDialog: Subject<string> = new Subject<string>();
}
